import styled from 'styled-components';
import Icon from '../Icon';
import Input from '../Input';
export const SelectStyled = styled(Input)(({ theme, }) => ({
    minWidth: '100px',
}));
export const OptionStyled = styled.option(({ theme, }) => ({}));
export const SelectIcon = styled(Icon)(({ theme, name, }) => {
    var _a, _b;
    return ({
        top: 'calc(50% - 0.75em) !important',
        color: (_b = (_a = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _a === void 0 ? void 0 : _a.text) === null || _b === void 0 ? void 0 : _b.primary,
        svg: {
            height: '1.5em',
            width: 'auto',
        },
    });
});
//# sourceMappingURL=Select.styles.js.map